import { connectBaseApi, containerClient, createRpcMutation, createRpcQuery } from "@racoon/api";

export const containerGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listContainers: createRpcQuery(build, containerClient, "listContainers", {
      providesTags: ["Container"],
    }),
    getContainerById: createRpcQuery(build, containerClient, "getContainerById"),
    createContainer: createRpcMutation(build, containerClient, "createContainer", {
      invalidatesTags: ["Container"],
    }),
    updateContainer: createRpcMutation(build, containerClient, "updateContainer", {
      invalidatesTags: ["Container"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListContainersQuery,
  useGetContainerByIdQuery,
  useCreateContainerMutation,
  useUpdateContainerMutation,
} = containerGrpc;
